/**
 * Listas curtas do que muda na troca de plano, comparando o config dos dois
 * planos (limits, permissions, features). null em um limite = ilimitado.
 */

const LIMITS = [
  { key: 'resources', unlimited: 'ilimitados', noun: 'profissionais', nounOne: 'profissional' },
  { key: 'users', unlimited: 'ilimitados', noun: 'usuários', nounOne: 'usuário' },
  { key: 'rooms', unlimited: 'ilimitadas', noun: 'agendas/salas', nounOne: 'agenda/sala' },
];

const PERMISSIONS = [
  { key: 'focus_nfse_integration', label: 'Integração com Focus NFe' },
  { key: 'patient_registration_link', label: 'Link para o paciente preencher o próprio cadastro' },
];

// O limite `a` é maior que `b`? (null = ilimitado)
const isHigher = (a, b) => {
  if (a === undefined || b === undefined || b === null) return false;
  return a === null || a > b;
};

/** O que o plano novo passa a ter a mais que o atual (mesma regra de antes da reforma visual). */
export function buildUpgradeBenefits(currentConfig, newConfig) {
  const benefits = [];
  if (!currentConfig || !newConfig) return benefits;

  const curr = currentConfig.limits || {};
  const next = newConfig.limits || {};
  LIMITS.forEach(({ key, unlimited, noun }) => {
    if (next[key] === undefined) return;
    if (!(curr[key] === null || next[key] > curr[key] || next[key] === null)) return;
    const from = curr[key] === null ? unlimited : curr[key];
    const to = next[key] === null ? unlimited : next[key];
    if (String(from) !== String(to)) benefits.push(`Até ${to} ${noun}`);
  });

  const currPerms = currentConfig.permissions || {};
  const nextPerms = newConfig.permissions || {};
  PERMISSIONS.forEach(({ key, label }) => {
    if (!currPerms[key] && nextPerms[key]) benefits.push(label);
  });

  const currFeats = currentConfig.features || {};
  const nextFeats = newConfig.features || {};
  if (currFeats.dashboard !== nextFeats.dashboard && nextFeats.dashboard === 'advanced') {
    benefits.push('Dashboard avançado');
  }

  return benefits;
}

/** O que deixa de ter ao trocar para um plano menor. */
export function buildDowngradeLosses(currentConfig, newConfig) {
  const losses = [];
  if (!currentConfig || !newConfig) return losses;

  const curr = currentConfig.limits || {};
  const next = newConfig.limits || {};
  LIMITS.forEach(({ key, noun, nounOne }) => {
    if (!isHigher(curr[key], next[key])) return;
    losses.push(`Limite passa a ser de ${next[key]} ${next[key] === 1 ? nounOne : noun}`);
  });

  const currPerms = currentConfig.permissions || {};
  const nextPerms = newConfig.permissions || {};
  PERMISSIONS.forEach(({ key, label }) => {
    if (currPerms[key] && !nextPerms[key]) losses.push(label);
  });

  const currFeats = currentConfig.features || {};
  const nextFeats = newConfig.features || {};
  if (currFeats.dashboard === 'advanced' && nextFeats.dashboard !== 'advanced') {
    losses.push('Dashboard avançado');
  }

  return losses;
}
